var _path, _g, _path2, _path3, _path4, _g2, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 237,
    viewBox: "0 0 251 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2715 5.1914C10.2715 4.08683 11.1669 3.19141 12.2715 3.19141L169.623 3.19141C170.245 3.19141 170.831 3.48065 171.21 3.97402L249.652 106.221C249.92 106.57 250.065 106.998 250.065 107.438V236.801H80.7439L10.8331 164.435C10.4728 164.062 10.2715 163.564 10.2715 163.046V5.1914Z",
    fill: "url(#paint0_linear_8761_131969)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8761_131969)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.08008,
    y: 1,
    width: 160.663,
    height: 160.663,
    rx: 4,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.487092,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0352 13.9532C19.0352 12.8486 19.9306 11.9532 21.0352 11.9532H156.519C157.624 11.9532 158.519 12.8486 158.519 13.9532V150.168C158.519 151.272 157.624 152.168 156.519 152.168H21.0352C19.9306 152.168 19.0352 151.272 19.0352 150.168V13.9532Z",
    fill: "url(#paint1_linear_8761_131969)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_131969)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3042 11.2227H159.249V117.162L156.348 112.023L153.675 121.318L149.442 116.765L145.783 118.623L134.938 116.765L132.932 152.168L128.289 152.246L124.904 151.04L118.17 152.168L113.522 150.268L106.501 152.168L102.849 108.344L98.9581 152.168L93.055 151L87.5773 152.733L80.3936 150.707L69.3787 152.168L66.1313 149.926L62.6661 152.168H55.0172V55.0397C55.0172 55.0397 52.0901 97.3822 46.5746 108.344C44.2174 113.029 40.4199 114.3 37.9351 115.388C34.6056 116.845 32.0895 117.162 23.794 117.162C9.30719 117.162 4.30664 101.799 4.30664 101.799C4.30664 101.799 9.88969 97.9057 13.3833 89.9873C16.8768 82.0689 18.3042 55.0397 18.3042 55.0397V11.2227Z",
    fill: "url(#paint2_linear_8761_131969)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8761_131969",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 11,
    width: 156,
    height: 142
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3042 11.2227H159.249V117.162L156.348 112.023L153.675 121.318L149.442 116.765L145.783 118.623L134.938 116.765L132.932 152.168L128.289 152.246L124.904 151.04L118.17 152.168L113.522 150.268L106.501 152.168L102.849 108.344L98.9581 152.168L93.055 151L87.5773 152.733L80.3936 150.707L69.3787 152.168L66.1313 149.926L62.6661 152.168H55.0172V55.0397C55.0172 55.0397 52.0901 97.3822 46.5746 108.344C44.2174 113.029 40.4199 114.3 37.9351 115.388C34.6056 116.845 32.0895 117.162 23.794 117.162C9.30719 117.162 4.30664 101.799 4.30664 101.799C4.30664 101.799 9.88969 97.9057 13.3833 89.9873C16.8768 82.0689 18.3042 55.0397 18.3042 55.0397V11.2227Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8761_131969)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.9788 57.2852V63.9062H28.2463L27.8362 58.7793L45.6194 30.5664H52.3284L45.0627 42.7246L36.2151 57.2852H58.9788ZM54.1448 30.5664V73.2227H45.7073V30.5664H54.1448ZM108.303 48.1445V55.5273C108.303 58.7305 107.961 61.4941 107.277 63.8184C106.594 66.123 105.607 68.0176 104.318 69.502C103.049 70.9668 101.535 72.0508 99.7771 72.7539C98.0193 73.457 96.0662 73.8086 93.9177 73.8086C92.199 73.8086 90.5974 73.5938 89.1131 73.1641C87.6287 72.7148 86.2908 72.0215 85.0994 71.084C83.9275 70.1465 82.9119 68.9648 82.0525 67.5391C81.2127 66.0938 80.5681 64.375 80.1189 62.3828C79.6697 60.3906 79.4451 58.1055 79.4451 55.5273V48.1445C79.4451 44.9414 79.7869 42.1973 80.4705 39.9121C81.1736 37.6074 82.1599 35.7227 83.4295 34.2578C84.7185 32.793 86.242 31.7188 87.9998 31.0352C89.7576 30.332 91.7107 29.9805 93.8591 29.9805C95.5779 29.9805 97.1697 30.2051 98.6345 30.6543C100.119 31.084 101.457 31.7578 102.648 32.6758C103.84 33.5938 104.855 34.7754 105.695 36.2207C106.535 37.6465 107.179 39.3555 107.629 41.3477C108.078 43.3203 108.303 45.5859 108.303 48.1445ZM99.8357 56.6406V47.002C99.8357 45.459 99.7478 44.1113 99.572 42.959C99.4158 41.8066 99.1716 40.8301 98.8396 40.0293C98.5076 39.209 98.0974 38.5449 97.6091 38.0371C97.1209 37.5293 96.5642 37.1582 95.9392 36.9238C95.3142 36.6895 94.6209 36.5723 93.8591 36.5723C92.9021 36.5723 92.0525 36.7578 91.3103 37.1289C90.5877 37.5 89.9724 38.0957 89.4646 38.916C88.9568 39.7168 88.5662 40.791 88.2927 42.1387C88.0388 43.4668 87.9119 45.0879 87.9119 47.002V56.6406C87.9119 58.1836 87.99 59.541 88.1463 60.7129C88.322 61.8848 88.5759 62.8906 88.908 63.7305C89.2595 64.5508 89.6697 65.2246 90.1384 65.752C90.6267 66.2598 91.1834 66.6309 91.8084 66.8652C92.4529 67.0996 93.156 67.2168 93.9177 67.2168C94.8552 67.2168 95.6853 67.0312 96.408 66.6602C97.1502 66.2695 97.7752 65.6641 98.283 64.8438C98.8103 64.0039 99.2009 62.9102 99.4548 61.5625C99.7088 60.2148 99.8357 58.5742 99.8357 56.6406ZM159.97 57.2852V63.9062H129.238L128.827 58.7793L146.611 30.5664H153.32L146.054 42.7246L137.206 57.2852H159.97ZM155.136 30.5664V73.2227H146.699V30.5664H155.136Z",
    fill: "url(#paint3_linear_8761_131969)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 95.6133H37.4833C37.4833 95.6133 40.3187 109.826 46.7045 108.183C43.9331 113.821 38.1545 118.208 25.8645 118.208C13.5745 118.208 8.48522 113.516 5.44345 110.235C2.40169 106.953 0 95.6133 0 95.6133Z",
    fill: "url(#paint4_linear_8761_131969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8761_131969",
    x: 3.08008,
    y: 0,
    width: 190.662,
    height: 190.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.0403646 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8761_131969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8761_131969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8761_131969",
    x1: 266.669,
    y1: 91.1981,
    x2: 96.7261,
    y2: -86.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4B0D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8761_131969",
    x1: 76.0312,
    y1: 125.129,
    x2: 61.6276,
    y2: 84.0868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C8DE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B798E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8761_131969",
    x1: 12.0131,
    y1: 1.53399,
    x2: -5.7509,
    y2: 129.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8761_131969",
    x1: 28.4846,
    y1: 18.8838,
    x2: 21.2242,
    y2: 113.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8761_131969",
    x1: -11.1766,
    y1: 96.4221,
    x2: -10.3924,
    y2: 126.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_131969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.551,
    height: 141.675,
    fill: "white",
    transform: "translate(3.69922 11.2227)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5587b279be700679878030a5c54cb94c.svg";
export { ForwardRef as ReactComponent };